<button
  class="op-back-button button hide-when-print"
  data-test-selector="op-back-button"
  [ngClass]="linkClass"
  [title]="text.goBack"
  (click)="goBack()"
>
  <op-icon icon-classes="op-back-button--icon button--icon icon-back-up" />
</button>
